export enum ValidationPattern {
  ONLY_NUMERIC = "^[0-9]+$",
  ONLY_DECIMAL = "^[0-9]+(\\.[0-9]+)?$",
  EMAIL = "^[a-zA-Z0-9.+_-]+@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\\.)+[a-zA-Z]{2,}$",
}
